import { Injectable, signal } from "@angular/core";

/**
 * Compteur de MUTATIONS de spécification — « quelque chose vient d'être écrit ».
 *
 * Les écrans de spécification affichent des dérivés de l'état complet d'une
 * version : le compteur « Modifications (N) » de la barre, par exemple, est un
 * diff calculé côté back. Ces dérivés doivent se rafraîchir après CHAQUE
 * écriture, quel que soit l'onglet qui l'a faite — infos, nomenclature,
 * procédés, contrôles, logistique, allergènes…
 *
 * Les brancher un par un ne tient pas : c'est précisément ce qui avait produit
 * un compteur figé jusqu'au F5 (retour Yoann du 18/09/2026), et le prochain
 * onglet ajouté aurait rouvert le trou. Le signal est donc alimenté par un
 * intercepteur HTTP, au seul endroit où TOUTES les écritures passent
 * nécessairement.
 */
@Injectable({ providedIn: "root" })
export class SpecMutationsService {
  /** Incrémenté à chaque écriture aboutie sur une entité de spécification. */
  readonly mutations = signal(0);

  signaler(): void {
    this.mutations.update((n) => n + 1);
  }
}
